import { ItemViewModel, ItemViewModel1 } from '../ItemViewModel';

export class InventryFlowReport {
    public FK_Item :ItemViewModel;
    public MastId: number;
    public RefId :string;
    public quantity :number;
    public Oldquantity:number;
    public TansactionType: string;
    public Type :string;
    public TrnasactionDate: Date;
    public StockInCount :number;
    public StockOutCount :number;
    public Price: number;
}


export class InventryFlowReportView {
    public item :ItemViewModel1;
    public mastId: number;
    public refId :string;
    public quantity :number;
    public oldQuantity:number;
    public transactionType: string;
    public type :string;
    public transactionDate: Date;
    public stockInCount :number;
    public stockOutCount :number;
    public price: number;
}